import { CreatableProps, CreatableSelect, OptionTypeBase } from '@cad-arc';
import { GroupBase, SelectInstance } from 'react-select';
import { useInputSizeForApplicationType } from '../../common/hooks/use-input-size-for-application-type';

export function BaseCreatableSelect<
    OptionType extends OptionTypeBase,
    Multi extends boolean = false
>(
    props: Omit<CreatableProps<OptionType, Multi>, 'ref'> & {
        ref?: React.Ref<SelectInstance<unknown, false, GroupBase<unknown>> | undefined> | undefined;
    }
) {
    const { size: propsSize, ...otherProps } = props;
    const isTestEnv = window.Cypress;
    const size = useInputSizeForApplicationType(propsSize);

    return (
        // eslint-disable-next-line react/forbid-elements
        <CreatableSelect
            matchSort
            {...otherProps}
            closeMenuOnScroll={(e) => {
                const target = e.target;
                return !(
                    target === document ||
                    (target instanceof HTMLElement &&
                        target?.className?.includes('arc-select__menu-list'))
                );
            }}
            menuPortalTarget={
                isTestEnv ? undefined : document.getElementById('chakra-toast-portal')
            }
            // @ts-expect-error This wants a number but the var is better.
            menuPortalZIndex="var(--arc-zIndices-toast)"
            onKeyDown={(e) => {
                if (e.key === 'Enter') e.stopPropagation();
            }}
            tabSelectsValue={false}
            size={size}
        />
    );
}
